'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImmutableTermIdMap = require('self-service-api/constants/ImmutableTermIdMap');

var _ImmutableTermIdMap2 = _interopRequireDefault(_ImmutableTermIdMap);

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var discountAdapter = function discountAdapter(merchandiseId, termId, currentSubscriptions, products) {
  var termDiscount = _ImmutableTermIdMap2.default[termId].discountPercent;

  // Initially we'll only do this for seated products
  // We'll also do this for Marketing Starter contacts, so that they
  // can see the discount they'll get on those contacts
  if (!currentSubscriptions || _MerchandiseIdLists.SEATED_MERCHANDISE_IDS.indexOf(merchandiseId) === -1 && merchandiseId !== MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS) {
    return termDiscount;
  }

  if (merchandiseId in currentSubscriptions) {
    return currentSubscriptions[merchandiseId].discountPercentage / 100;
  }

  // Because of the experiment we ran where the SKU and contacts were discounted
  // differently, if we can't find the contacts discount don't look
  // for the parent SKU's
  if (merchandiseId === MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS) {
    return termDiscount;
  }

  var parentDiscount = null;
  var parentItemIds = products[merchandiseId] && products[merchandiseId].parentItemIds || [];
  parentItemIds.forEach(function (parentProductId) {
    if (parentProductId in currentSubscriptions) {
      parentDiscount = currentSubscriptions[parentProductId].discountPercentage / 100;
    }
  });

  if (parentDiscount) return parentDiscount;

  return termDiscount;
};

exports.default = discountAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/discountAdapter.js
// module id = 322
// module chunks = 3 4 5